import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  UserConnectedLeadersListLoadAction,
  UserConnectedLeadersListLoadMoreAction,
} from '../../domains/leadersManagement/actions.types';

import { AllUserConnectedLeaders, UserConnectedLeadersList } from './types';

export type UserConnectedLeadersListAction =
  | UserConnectedLeadersListLoadAction
  | UserConnectedLeadersListLoadMoreAction;

const initialState: AllUserConnectedLeaders = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreFulfilledUserConnectedLeadersList = (
  state: AllUserConnectedLeaders,
  userConnectedLeadersList: UserConnectedLeadersList
): AllUserConnectedLeaders => {
  const currentUserConnectedLeadersIds = state.fulfilled?.userConnectedLeaders ?? [];

  return {
    ...state,
    fulfilled: {
      ...userConnectedLeadersList,
      userConnectedLeaders: [...currentUserConnectedLeadersIds, ...userConnectedLeadersList.userConnectedLeaders],
    },
  };
};

const reducer: Reducer<AllUserConnectedLeaders, UserConnectedLeadersListAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CONNECTED_LEADERS.LOAD_PENDING':
      return setPending();
    case 'CONNECTED_LEADERS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.userConnectedLeadersList);
    case 'CONNECTED_LEADERS.LOAD_MORE_FULFILLED':
      return loadMoreFulfilledUserConnectedLeadersList(state, action.payload.entities.userConnectedLeadersList);
    case 'CONNECTED_LEADERS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
